import { Navigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Page } from '../../layout/AppLayout.jsx'
import Tabs from '../../components/ui/Tabs.jsx'
import { useCompany } from '../../context/CompanyContext.jsx'
import VatRatesTab from './VatRatesTab.jsx'
import PlansTab from './PlansTab.jsx'
import JobsTab from './JobsTab.jsx'
import JobHistoryTab from './JobHistoryTab.jsx'
import AuditTab from './AuditTab.jsx'
import EmailTemplatesTab from './EmailTemplatesTab.jsx'

/*
 * Administration console — inventory §3. Super-administrateur only. Tabbed:
 * companies, users, VAT rates (CRUD), billing plans, scheduled jobs. Active tab
 * mirrored to ?tab=.
 */
export default function AdminPage() {
  const { t } = useTranslation()
  const { isSuperAdmin } = useCompany()
  const [params, setParams] = useSearchParams()

  if (!isSuperAdmin()) return <Navigate to="/app/dashboard" replace />

  const tabs = [
    { key: 'vat-rates', icon: 'invoice', label: t('admin.tabs.vatRates'), el: <VatRatesTab /> },
    { key: 'plans', icon: 'credit-card', label: t('admin.tabs.plans'), el: <PlansTab /> },
    { key: 'templates', icon: 'mail', label: t('admin.tabs.templates'), el: <EmailTemplatesTab /> },
    { key: 'jobs', icon: 'settings', label: t('admin.tabs.jobs'), el: <JobsTab /> },
    { key: 'job-history', icon: 'invoice', label: t('admin.tabs.jobHistory'), el: <JobHistoryTab /> },
    { key: 'audit', icon: 'eye', label: t('admin.tabs.audit'), el: <AuditTab /> },
  ]
  const active = tabs.some((tb) => tb.key === params.get('tab')) ? params.get('tab') : 'vat-rates'
  const current = tabs.find((tb) => tb.key === active)

  return (
    <Page title={t('admin.title')}>
      <Tabs tabs={tabs} active={active} onChange={(k) => setParams({ tab: k }, { replace: true })} />
      {current?.el}
    </Page>
  )
}
